
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pawnId"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pawnHash"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"as"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ANY"}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"anyRoleList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"context"},"value":{"kind":"EnumValue","value":"GLOBAL"}},{"kind":"Argument","name":{"kind":"Name","value":"pawnId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pawnId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pawnHash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pawnHash"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentProgressList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deploymentHandle"},"value":{"kind":"StringValue","value":"unstuck_course","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assignmentProgressId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assignmentHandle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"devTags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Flexibility"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Organization"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Planning"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Initiation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"WorkingMemory"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Inhibition"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"SelfMonitoring"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"EmotionalControl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"MostPowered"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"LeastPowered"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"LearnsBestVisually"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Creative"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"LearnsSmallChunks"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ConstructsBuildings"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Humor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Artistic"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"RemembersDetails"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"RemembersFacts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Engaging"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Caring"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Loving"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Generous"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Kind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Thoughtful"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"GreatWithTechnology"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Persistent"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":1230}};
    doc.loc.source = {"body":"query ($pawnId: [Int], $pawnHash: [String]) {\n    roles(as: [ANY]) {\n        anyRoleList(context: GLOBAL, pawnId: $pawnId, pawnHash: $pawnHash) {\n            assignmentProgressList(deploymentHandle: \"unstuck_course\") {\n                completed\n                assignmentProgressId\n                assignmentHandle\n                devTags {\n                    Flexibility\n                    Organization\n                    Planning\n                    Initiation\n                    WorkingMemory\n                    Inhibition\n                    SelfMonitoring\n                    EmotionalControl\n                    MostPowered\n                    LeastPowered\n                    LearnsBestVisually\n                    Creative\n                    LearnsSmallChunks\n                    ConstructsBuildings\n                    Humor\n                    Artistic\n                    RemembersDetails\n                    RemembersFacts\n                    Engaging\n                    Caring\n                    Loving\n                    Generous\n                    Kind\n                    Thoughtful\n                    GreatWithTechnology\n                    Persistent\n                }\n            }\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
